import React, { FC } from 'react'
import styled from 'styled-components'
import { HeaderHeight } from './var'

interface HeaderProps {
  transparent?: boolean
  noShadow?: boolean
}

const HeaderContent = styled.div`
  width: 100vw;
  padding: 0 100px;
  height: ${HeaderHeight};
  min-height: ${HeaderHeight};
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 600px) {
    padding: 0 15px;
  }
`

const HeaderContainer = styled.div<HeaderProps>`
  z-index: 100;
  display: flex;
  align-items: center;
  height: ${HeaderHeight};
  min-height: ${HeaderHeight};
  width: 100vw;
  justify-content: center;
  ${({ transparent }) => (transparent ? '' : 'box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.12);')}
  background-color: ${({ transparent }) => (transparent ? 'transparent' : '#fff')};
  ${({ noShadow }) => ( noShadow && 'box-shadow: none;' )}
`

export const Header: FC<HeaderProps> = (props) => (
  <HeaderContainer {...props}>
    <HeaderContent>{props.children}</HeaderContent>
  </HeaderContainer>
)
